import { Directive, ElementRef, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ScrollDirection, SharedService } from 'src/app/services/shared.service';

@Directive({
  selector: '[sticky-bar]'
})
export class StickyBarDirective {

  constructor(private host: ElementRef, private sharedService: SharedService) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  @Input('sticky-bar') data: string;
  get classes() {
    return ['sticky', ...(this.data || null)?.split(' ') || []];
  }

  private unsubscribe$ = new Subject<void>();

  ngAfterContentInit(): void {
    if (!this.sharedService.isBrowser) return;

    var lastScrollY: number;
    var height: number;
    var stickyTop: number;

    this.sharedService.scroll$(1)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(_ => {
        if (!this.host) return;
        height = this.host.nativeElement.clientHeight;
        var delta = Math.min(30, 3 * Math.abs(lastScrollY - _.scrollY));
        lastScrollY = _.scrollY;

        if (_.scrollY > height)
          switch (_.direction) {
            case ScrollDirection.Down:
              if (stickyTop > -height)
                stickyTop -= delta;
              if (stickyTop == undefined || stickyTop < -height)
                stickyTop = -height;
              break;
            case ScrollDirection.Up:
              if (stickyTop < 0)
                stickyTop += delta;
              if (stickyTop > 0)
                stickyTop = 0;
              break;
          }
        else
          stickyTop = undefined;

        this.host.nativeElement.style.top = !isNaN(stickyTop) ? stickyTop + 'px' : '';
        if (stickyTop != undefined)
          this.host.nativeElement.classList.add(...this.classes);
        else this.host.nativeElement.classList.remove(...this.classes);
      });
  }
}
